import { c } from '../../contract';
import { adminRouter } from './admin.router';
import { bookShopRouter } from './book-shop.router';
import { userRouter } from './user.router';
import { userBlocksRouter } from './userBlocks.router';
import { userProfileRouter } from './userProfile.router';
import { userStoriesCommentsRouter } from './userStoriesComments.router';

export const v2Router = c.router(
  {
    admin: adminRouter,
    bookShop: bookShopRouter,
    userBlocks: userBlocksRouter,
    userStoriesComments: userStoriesCommentsRouter,
    userProfile: userProfileRouter,
    user: userRouter,
  },
  { pathPrefix: '/v2' },
);
